<app-visor />
<section>
    <main *ngIf="this.trans" class="grid p-fluid col-12 lg:col-10">
        <!-- Información de la Empresa -->
        <div class="col-12 md:col-4">
            <div>
                <b>{{ trans.nombre }}:</b>
            </div>
            <div>
                <p *ngIf="isLoading; else nombre">
                    <p-skeleton width="10rem"></p-skeleton>
                </p>
                <ng-template #nombre>
                    <p>{{ data.nombre }}</p>
                </ng-template>
            </div>
        </div>
        <div class="col-12 md:col-4">
            <div>
                <b>{{ trans.correo }}:</b>
            </div>
            <div>
                <p *ngIf="isLoading; else correo">
                    <p-skeleton width="10rem"></p-skeleton>
                </p>
                <ng-template #correo>
                    <p>{{ data.correo }}</p>
                </ng-template>
            </div>
        </div>
        <div class="col-12 md:col-4">
            <div>
                <b>{{ trans.telefono }}:</b>
            </div>
            <div>
                <p *ngIf="isLoading; else telefono">
                    <p-skeleton width="10rem"></p-skeleton>
                </p>
                <ng-template #telefono>
                    <p>{{ data.telefono }}</p>
                </ng-template>
            </div>
        </div>
        <div class="col-12 md:col-4">
            <div>
                <b>{{ trans.direccion }}:</b>
            </div>
            <div>
                <p *ngIf="isLoading; else direccion">
                    <p-skeleton width="10rem"></p-skeleton>
                </p>
                <ng-template #direccion>
                    <p>{{ data.direccion }}</p>
                </ng-template>
            </div>
        </div>
        <div class="col-12 md:col-8">
            <div>
                <b> {{ trans.nit }}: </b>
            </div>
            <div>
                <p *ngIf="isLoading; else nit">
                    <p-skeleton width="10rem"></p-skeleton>
                </p>
                <ng-template #nit>
                    <p>{{ data.nit }}</p>
                </ng-template>
            </div>
        </div>
        <div class="col-12 md:col-6">
            <div>
                <b>{{ trans.documento }}:</b>
            </div>
            <div>
                <p *ngIf="isLoading; else rutaDocumento">
                    <p-skeleton width="10rem"></p-skeleton>
                </p>
                <ng-template #rutaDocumento>
                    <div class="flex gap-2 align-items-center">
                        <i class="pi pi-file-pdf" style="font-size: 1.5rem; color:crimson"></i>
                        <div>
                            {{ data.nombre }}
                        </div>
                        <button pButton icon="pi pi-desktop" (click)="downloadFormFile(false)"
                            [disabled]="!ls.hasRole(role.ADMIN_TRAM)"></button>
                        <button pButton icon="pi pi-download" class="p-button-success"
                            (click)="downloadFormFile(true)" [disabled]="!ls.hasRole(role.ADMIN_TRAM)"></button>
                    </div>
                </ng-template>
            </div>
        </div>
    </main>
</section>